"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/static-property-placement */
/**
 * Copyright (c) 2016 Konstantin Kulinicenko.
 * Licensed under the MIT License (MIT), see
 * https://github.com/40818419/react-code-input
 */
const react_1 = __importStar(require("react"));
const utils_1 = require("../../../lib/utils");
const theme_1 = __importDefault(require("../../../styles/theme"));
const BACKSPACE_KEY = 8;
const TAB_KEY = 9;
const LEFT_ARROW_KEY = 37;
const UP_ARROW_KEY = 38;
const RIGHT_ARROW_KEY = 39;
const DOWN_ARROW_KEY = 40;
const E_KEY = 69;
const MINUS_KEY_NUMPAD = 109;
const PLUS_KEY_NUMPAD = 107;
const MINUS_KEY = 189;
const PLUS_KEY = 187;
const ReactCodeInput = (_a) => {
    var { autoComplete = 'off', ariaLabel = 'verification code input digit', isValid = true, disabled = false, forceUppercase = false, fields = 5, value = '', type = 'text', filterKeyCodes = [189, 190], filterChars = ['-', '.'], filterCharsIsWhitelist = false } = _a, props = __rest(_a, ["autoComplete", "ariaLabel", "isValid", "disabled", "forceUppercase", "fields", "value", "type", "filterKeyCodes", "filterChars", "filterCharsIsWhitelist"]);
    const initialState = {
        value,
        fields,
        input: [],
        isValid,
        disabled,
        filterKeyCodes,
        defaultInputStyle: {
            fontFamily: 'monospace',
            MozAppearance: 'textfield',
            borderRadius: '6px',
            border: '1px solid',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,.10)',
            margin: '4px',
            paddingLeft: '8px',
            paddingRight: 0,
            width: '36px',
            height: '42px',
            fontSize: '32px',
            boxSizing: 'border-box',
        },
    };
    const [state, setState] = react_1.default.useState(initialState);
    const { fields: fieldsState } = state;
    react_1.useEffect(() => {
        const tempInput = [];
        const numFields = Number(fieldsState);
        for (let i = 0; i < numFields; i += 1) {
            if (i < 32) {
                tempInput.push(value[i] || '');
            }
        }
        setState(Object.assign(Object.assign({}, state), { input: tempInput }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const textInput = [];
    react_1.useEffect(() => {
        if (!isValid) {
            const newTarget = textInput[0];
            if (newTarget) {
                newTarget.focus();
                newTarget.select();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isValid]);
    const uuid = utils_1.uuidv4();
    if (forceUppercase) {
        // eslint-disable-next-line no-param-reassign
        value = value === null || value === void 0 ? void 0 : value.toUpperCase();
    }
    const handleTouch = (newValue) => {
        const { touch, untouch, name } = props;
        if (typeof touch === 'function' && typeof untouch === 'function') {
            if (newValue === '') {
                touch(name);
            }
            else {
                untouch(name);
            }
        }
    };
    const handleBlur = (e) => {
        var _a;
        handleTouch((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    const handleChange = (e) => {
        const { onChange } = props;
        let newValue = String(e.target.value);
        if (forceUppercase) {
            newValue = newValue.toUpperCase();
        }
        if (type === 'number') {
            newValue = newValue.replace(/[^\d]/g, '');
        }
        /** Filter Chars */
        newValue = newValue
            .split('')
            .filter((currChar) => {
            if (filterCharsIsWhitelist) {
                return filterChars.includes(currChar);
            }
            return !filterChars.includes(currChar);
        })
            .join('');
        let fullValue = newValue;
        if (newValue !== '') {
            const { input: inputState } = state;
            const input = inputState.slice();
            if (newValue.length > 1) {
                newValue.split('').map((chart, i) => {
                    if (Number(e.target.dataset.id) + i < fields) {
                        input[Number(e.target.dataset.id) + i] = chart;
                    }
                    return false;
                });
            }
            else {
                input[Number(e.target.dataset.id)] = newValue;
            }
            input.map((s, i) => {
                if (textInput[i]) {
                    textInput[i].value = s;
                }
                return false;
            });
            const idValue = Number(e.target.dataset.id);
            // focus on first box when at the last box, even when copy and paste
            const targetIndex = newValue.length + idValue < input.length
                ? Number(e.target.dataset.id) + 1
                : 0;
            const newTarget = textInput[targetIndex];
            if (newTarget) {
                newTarget.focus();
                newTarget.select();
            }
            fullValue = input.join('');
            setState(Object.assign(Object.assign({}, state), { value: input.join(''), input }));
        }
        if (onChange && fullValue) {
            onChange(fullValue);
        }
        handleTouch(fullValue);
    };
    const handleKeyDown = (e) => {
        if (!(e.target instanceof HTMLInputElement)) {
            return;
        }
        if (e.keyCode === TAB_KEY) {
            return;
        }
        const target = Number(e.target.dataset.id);
        const nextTarget = textInput[target + 1];
        const prevTarget = textInput[target - 1];
        let input;
        let newValue;
        const { onChange } = props;
        const { input: inputState } = state;
        if (filterKeyCodes.length > 0) {
            filterKeyCodes.forEach((item) => {
                if (item === e.keyCode) {
                    e.preventDefault();
                }
            });
        }
        switch (e.keyCode) {
            case BACKSPACE_KEY:
                e.preventDefault();
                textInput[target].value = '';
                input = inputState.slice();
                input[target] = '';
                newValue = input.join('');
                setState(Object.assign(Object.assign({}, state), { value: newValue, input }));
                if (textInput[target].value === '') {
                    if (prevTarget) {
                        prevTarget.focus();
                        prevTarget.select();
                    }
                }
                if (onChange) {
                    onChange(newValue);
                }
                break;
            case LEFT_ARROW_KEY:
                e.preventDefault();
                if (prevTarget) {
                    prevTarget.focus();
                    prevTarget.select();
                }
                break;
            case RIGHT_ARROW_KEY:
                e.preventDefault();
                if (nextTarget) {
                    nextTarget.focus();
                    nextTarget.select();
                }
                break;
            case UP_ARROW_KEY:
                e.preventDefault();
                break;
            case DOWN_ARROW_KEY:
                e.preventDefault();
                break;
            case MINUS_KEY:
            case MINUS_KEY_NUMPAD:
            case PLUS_KEY:
            case PLUS_KEY_NUMPAD:
            case E_KEY: // This case needs to be handled because of https://stackoverflow.com/questions/31706611/why-does-the-html-input-with-type-number-allow-the-letter-e-to-be-entered-in
                if (e.target.type === 'number') {
                    e.preventDefault();
                    break;
                }
                break;
            default:
                if (e.target.type === 'number' && !Number.isInteger(+e.key)) {
                    e.preventDefault();
                    break;
                }
                else if (e.target.value === e.key && nextTarget) {
                    e.preventDefault();
                    const { value: valueState } = state;
                    if (onChange) {
                        onChange(valueState);
                    }
                    nextTarget.focus();
                    nextTarget.select();
                }
                break;
        }
        handleTouch(newValue || '');
    };
    const { className, style = {}, inputStyle = {}, inputStyleInvalid = {}, innerRef, onBlur, onFocus, required, } = props;
    const { input, defaultInputStyle } = state;
    const styles = {
        container: Object.assign({ display: 'inline-block' }, style),
        input: isValid ? inputStyle : inputStyleInvalid,
    };
    if (!className && Object.keys(inputStyle).length === 0) {
        Object.assign(inputStyle, Object.assign(Object.assign({}, defaultInputStyle), { color: theme_1.default.colors.black, backgroundColor: theme_1.default.colors.white, borderColor: theme_1.default.colors.borderDefault }));
    }
    if (!className && Object.keys(inputStyleInvalid).length === 0) {
        Object.assign(inputStyleInvalid, Object.assign(Object.assign({}, defaultInputStyle), { color: theme_1.default.colors.error, backgroundColor: theme_1.default.colors.backgroundError, borderColor: theme_1.default.colors.error }));
    }
    if (disabled) {
        Object.assign(styles.input, {
            cursor: 'not-allowed',
            color: theme_1.default.colors.textInactive,
            borderColor: theme_1.default.colors.borderDefault,
            backgroundColor: theme_1.default.colors.white,
        });
    }
    return (react_1.default.createElement("div", { className: `react-code-input ${className}`, style: styles.container, ref: innerRef }, input.map((v, i) => (react_1.default.createElement("input", { ref: (ref) => {
            if (ref) {
                textInput[i] = ref;
            }
        }, id: `${uuid}-${i}`, "data-id": i, value: v, key: `input_${i}`, type: type, min: 0, max: 9, maxLength: input.length === i + 1 ? 1 : input.length, style: styles.input, autoComplete: autoComplete, "aria-label": `${ariaLabel} ${i + 1}`, "aria-required": required, name: `code-input-${i}`, onFocus: (e) => {
            e.target.select();
            if (onFocus) {
                onFocus(e);
            }
        }, onBlur: (e) => {
            handleBlur(e);
            if (onBlur) {
                onBlur(e);
            }
        }, onClick: props.onClick, onChange: handleChange, onKeyDown: handleKeyDown, disabled: state.disabled, "data-valid": state.isValid, pattern: props.pattern, inputMode: props.inputMode, placeholder: props.placeholder })))));
};
exports.default = ReactCodeInput;
